export const GET_LEAGUE_THREADS_SUCCESS =
  'Joga/messages/GET_LEAGUE_THREADS_SUCCESS';
export const GET_THREAD_MESSAGES_SUCCESS =
  'Joga/messages/GET_THREAD_MESSAGES_SUCCESS';
export const SET_CURRENT_THREAD = 'Joga/messages/SET_CURRENT_THREAD';
